import React from 'react';

import styles from './VerticalDivider.module.scss';

export const VerticalDivider: React.SFC = () => <div className={styles.verticalDivider} />;
